import { render, staticRenderFns } from "./ProductListingSkeleton.vue?vue&type=template&id=04690aaf&scoped=true&"
import script from "./ProductListingSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductListingSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductListingSkeleton.vue?vue&type=style&index=0&id=04690aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04690aaf",
  null
  
)

export default component.exports